<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'status-approval',
};
</script>

<style>

</style>
